import api from './api';
import type { LeaveRequest, CreateLeaveRequestData } from '../types/leaveRequest';

export const leaveRequestService = {
  // 休暇申請一覧取得
  async getLeaveRequests(): Promise<LeaveRequest[]> {
    const response = await api.get<LeaveRequest[]>('/leave-requests');
    return response.data;
  },

  // 休暇申請作成
  async createLeaveRequest(data: CreateLeaveRequestData): Promise<LeaveRequest> {
    const response = await api.post<{ message: string; leaveRequest: LeaveRequest }>('/leave-requests', data);
    return response.data.leaveRequest;
  },

  // 休暇申請承認
  async approveLeaveRequest(id: number): Promise<LeaveRequest> {
    const response = await api.put<{ message: string; leaveRequest: LeaveRequest }>(`/leave-requests/${id}/approve`);
    return response.data.leaveRequest;
  },

  // 休暇申請却下
  async rejectLeaveRequest(id: number): Promise<LeaveRequest> {
    const response = await api.put<{ message: string; leaveRequest: LeaveRequest }>(`/leave-requests/${id}/reject`);
    return response.data.leaveRequest;
  },

  // 休暇申請削除
  async deleteLeaveRequest(id: number): Promise<void> {
    await api.delete(`/leave-requests/${id}`);
  },

  // 休暇申請取消
  async cancelLeaveRequest(id: number): Promise<LeaveRequest> {
    const response = await api.put<{ message: string; leaveRequest: LeaveRequest }>(`/leave-requests/${id}/cancel`);
    return response.data.leaveRequest;
  },
};
